import { render, staticRenderFns } from "./ItemHighlight.vue?vue&type=template&id=364459ab&scoped=true&"
import script from "./ItemHighlight.vue?vue&type=script&lang=js&"
export * from "./ItemHighlight.vue?vue&type=script&lang=js&"
import style0 from "./ItemHighlight.vue?vue&type=style&index=0&id=364459ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364459ab",
  null
  
)

export default component.exports